import { render, staticRenderFns } from "./the-header.vue?vue&type=template&id=cb58a21a&scoped=true&"
import script from "./the-header.vue?vue&type=script&lang=js&"
export * from "./the-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb58a21a",
  null
  
)

export default component.exports